//TODO: Refactor so that parameterSets use PageID as key rather than array index -- better performance

import { Injectable } from '@angular/core';
import { cloneDeep } from 'src/ep-utils';

@Injectable()
export class PageParameterService {
  private CurrentPageID = '';
  private CurrentParentPageID = '';

  private parameterSets = [
    {
      PageID: '',
      ParentPageID: '',
      PageURL: '',
      PageParameters: {},
      DeleteSet: ''
    }
  ];

  constructor() {}

  createParameterSet(pageURL: string, pageParameters: any) {
    //console.log('createParameterSet  - begin');

    //console.log('CurrentPageID       = ' + this.CurrentPageID);
    //console.log('CurrentParentPageID = ' + this.CurrentParentPageID);

    var newRow = 0;
    var pageCount = 0;

    //console.log('pageURL             = ' + pageURL);
    //console.log('pageParameters      = ' + JSON.stringify(pageParameters));
    //console.log('parameterSets(1)    = ' + JSON.stringify(this.parameterSets));

    // Set parent page to current page
    this.CurrentParentPageID = this.CurrentPageID;

    this.CurrentPageID = this.generateUUID();

    //console.log('new pageID          = ' + this.CurrentPageID);

    if (!this.parameterSets) {
      newRow = 0;
    } else {
      newRow = this.parameterSets.length;
    }

    //console.log('PageID              = ' + this.CurrentPageID);
    //console.log('ParentPageID        = ' + this.CurrentParentPageID);
    //console.log('pageURL             = ' + pageURL);
    //console.log('PageParameters      = ' + JSON.stringify(pageParameters));

    //
    let pageParams = {};
    if (pageParameters) {
      try {
        pageParams = cloneDeep(pageParameters);
      } catch (err) {
        console.error('caught: ' + err);
      }
    }

    this.parameterSets[newRow] = {
      PageID: this.CurrentPageID,
      ParentPageID: this.CurrentParentPageID,
      PageURL: pageURL,
      PageParameters: pageParams,
      DeleteSet: ''
    };

    // Cleanup any orphaned parameter sets
    this.pruneParameterSets();

    //console.log('parameterSets(2)    = ' + JSON.stringify(this.parameterSets));
    //console.log('createParameterSet  - end');

    return this.CurrentPageID;
  }

  getPageURL(pageID: string): any {
    var pageURL: any;

    for (var i = 0; i < this.parameterSets.length; i++) {
      if (this.parameterSets[i].PageID == pageID) {
        pageURL = this.parameterSets[i].PageURL;
        break;
      }
    }

    return pageURL;
  }

  getParameterSet(paramSetID: string): any {
    //console.log('getParameterSet     - begin');
    //console.log('CurrentParentPageID = ' + this.CurrentParentPageID);

    var pageParameters: any;

    /* Find parameter set -- performance???? */
    for (var i = 0; i < this.parameterSets.length; i++) {
      if (this.parameterSets[i].PageID == paramSetID) {
        this.CurrentPageID = this.parameterSets[i].PageID;
        this.CurrentParentPageID = this.parameterSets[i].ParentPageID;
        pageParameters = this.parameterSets[i].PageParameters;
      } else {
        /* Error - pageID not found */
      }
    }

    //console.log('pageParameters      = ' + pageParameters);
    //console.log('getParameterSet     - end');

    return pageParameters;
  }

  setParameterSet(paramSetID: string, pageParameters: any) {
    //console.log('getParameterSet     - begin');
    //console.log('CurrentParentPageID = ' + this.CurrentParentPageID);

    /* Find parameter set -- performance???? */
    for (var i = 0; i < this.parameterSets.length; i++) {
      if (this.parameterSets[i].PageID == paramSetID) {
        this.parameterSets[i].PageParameters = cloneDeep(pageParameters);
      } else {
        /* Error - pageID not found */
      }
    }
  }

  getParameter(paramSetID: string, paramName: string): any {
    //console.log('paramSetID = ' + paramSetID);
    //console.log('paramName  = ' + paramName);

    if (!paramName) {
      return null;
    }

    if (!paramSetID) {
      paramSetID = this.CurrentPageID;
    }

    let pageParams = this.getParameterSet(paramSetID);

    let returnVal = '';

    try {
      returnVal = pageParams[paramName];
      if (returnVal && typeof returnVal === 'object') {
        returnVal = cloneDeep(returnVal); //clone to break direct reference
      }
    } catch {
      returnVal = null;
    }

    return returnVal;
  }

  getParameterWithDefault(paramSetID: string, paramName: string, defaultValue: any): any {
    if (!paramSetID || !paramName) {
      return null;
    }

    let pageParams = this.getParameterSet(paramSetID);

    let returnVal = defaultValue;

    try {
      returnVal = pageParams[paramName];
      if (returnVal && typeof returnVal === 'object') {
        returnVal = cloneDeep(returnVal); //clone to break direct reference
      }
    } catch {
      returnVal = defaultValue;
    }

    return returnVal;
  }

  setParameter(paramSetID: string, paramName: string, value: any) {
    if (!paramSetID || !paramName) {
      return;
    }

    let pageParams = this.getParameterSet(paramSetID);
    pageParams[paramName] = cloneDeep(value);
    this.setParameterSet(paramSetID, pageParams);
  }

  removeParameter(paramSetID: string, paramName: string) {
    if (!paramSetID || !paramName) {
      return;
    }

    let pageParams = this.getParameterSet(paramSetID);
    delete pageParams[paramName];
    this.setParameterSet(paramSetID, pageParams);
  }

  pruneParameterSets() {
    //console.log('pruneParameterSets  - begin');
    //console.log('CurrentPageID       = ' + this.CurrentPageID);
    //console.log('CurrentParentPageID = ' + this.CurrentParentPageID);

    let deleteParameterSets: string[] = [];
    let dCount = 0;
    let testID = '';

    // Cleanup any orphaned parameter sets
    let paramSetCount = this.parameterSets.length;

    //console.log('paramSetCount       = ' + paramSetCount);

    for (var i = 0; i < paramSetCount; i++) {
      if (
        this.parameterSets[i].ParentPageID &&
        this.parameterSets[i].ParentPageID == this.CurrentParentPageID &&
        this.parameterSets[i].PageID != this.CurrentPageID
      ) {
        this.parameterSets[i].DeleteSet = 'Y';

        // Check to see if set has a child
        for (var j = 0; j < paramSetCount; j++) {
          if (
            this.parameterSets[i].ParentPageID &&
            this.parameterSets[j].ParentPageID == this.parameterSets[i].PageID
          ) {
            this.parameterSets[j].DeleteSet = 'Y';
          }
        }
      }
    }

    //console.log('parameterSets(3)    = ' + JSON.stringify(this.parameterSets));

    // Now delete the orphaned sets
    for (var k = this.parameterSets.length - 1; k > -1; k -= 1) {
      if (this.parameterSets[k].DeleteSet == 'Y') {
        this.parameterSets.splice(k, 1);
      }
    }

    //console.log('pruneParameterSets  - end');
  }

  /* Do we have an existing method to generate GUID??? */
  generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
  }
}
